var currentUrl= location.protocol+'//'+window.location.hostname+window.location.pathname+window.location.search;

function sameHeight(minWidth, cssClass) {

	if ($(window).width() > minWidth) {

		var items = $(cssClass), // grab all the slides
		heights = [], // array to store heights
		tallest; // tallest slide

		if (items.length) {
			function normalizeHeights() {
				items.each(function() {
					heights.push($(this).outerHeight()); // add each slide's
					// height
				}); // to the array

				tallest = Math.max.apply(null, heights); // find the largest
				// height

				items.each(function() {
					$(this).css('min-height', tallest + 'px'); // set each
					// slide's
					// minimum
				}); // height to the largest
			}
			;

			normalizeHeights();
			$(window).on('resize orientationchange', function() {
				tallest = 0, heights.length = 0; // reset the variables

				items.each(function() {
					$(this).css('min-height', '0'); // reset each slide's height
				});

				normalizeHeights(); // run it again
			});
		}

	}

};

$('html').addClass('js');


var first=true;
if ($.cookie('first')=='true'){
	first=false;
}

var styles = {
default: null,
silver: [
  {
    elementType: 'geometry',
    stylers: [{color: '#f5f5f5'}]
  },
  {
    elementType: 'labels.icon',
    stylers: [{visibility: 'off'}]
  },
  {
    elementType: 'labels.text.fill',
    stylers: [{color: '#616161'}]
  },
  {
    elementType: 'labels.text.stroke',
    stylers: [{color: '#f5f5f5'}]
  },
  {
    featureType: 'administrative.land_parcel',
    elementType: 'labels.text.fill',
    stylers: [{color: '#bdbdbd'}]
  },
  {
    featureType: 'poi',
    elementType: 'geometry',
    stylers: [{color: '#eeeeee'}]
  },
  {
    featureType: 'poi',
    elementType: 'labels.text.fill',
    stylers: [{color: '#757575'}]
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry',
    stylers: [{color: '#e5e5e5'}]
  },
  {
    featureType: 'poi.park',
    elementType: 'labels.text.fill',
    stylers: [{color: '#9e9e9e'}]
  },
  {
    featureType: 'road',
    elementType: 'geometry',
    stylers: [{color: '#ffffff'}]
  },
  {
    featureType: 'road.arterial',
    elementType: 'labels.text.fill',
    stylers: [{color: '#757575'}]
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry',
    stylers: [{color: '#dadada'}]
  },
  {
    featureType: 'road.highway',
    elementType: 'labels.text.fill',
    stylers: [{color: '#616161'}]
  },
  {
    featureType: 'road.local',
    elementType: 'labels.text.fill',
    stylers: [{color: '#9e9e9e'}]
  },
  {
    featureType: 'transit.line',
    elementType: 'geometry',
    stylers: [{color: '#e5e5e5'}]
  },
  {
    featureType: 'transit.station',
    elementType: 'geometry',
    stylers: [{color: '#eeeeee'}]
  },
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [{color: '#c9c9c9'}]
  },
  {
    featureType: 'water',
    elementType: 'labels.text.fill',
    stylers: [{color: '#9e9e9e'}]
  }
],

night: [
  {elementType: 'geometry', stylers: [{color: '#242f3e'}]},
  {elementType: 'labels.text.stroke', stylers: [{color: '#242f3e'}]},
  {elementType: 'labels.text.fill', stylers: [{color: '#746855'}]},
  {
    featureType: 'administrative.locality',
    elementType: 'labels.text.fill',
    stylers: [{color: '#d59563'}]
  },
  {
    featureType: 'poi',
    elementType: 'labels.text.fill',
    stylers: [{color: '#d59563'}]
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry',
    stylers: [{color: '#263c3f'}]
  },
  {
    featureType: 'poi.park',
    elementType: 'labels.text.fill',
    stylers: [{color: '#6b9a76'}]
  },
  {
    featureType: 'road',
    elementType: 'geometry',
    stylers: [{color: '#38414e'}]
  },
  {
    featureType: 'road',
    elementType: 'geometry.stroke',
    stylers: [{color: '#212a37'}]
  },
  {
    featureType: 'road',
    elementType: 'labels.text.fill',
    stylers: [{color: '#9ca5b3'}]
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry',
    stylers: [{color: '#746855'}]
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.stroke',
    stylers: [{color: '#1f2835'}]
  },
  {
    featureType: 'road.highway',
    elementType: 'labels.text.fill',
    stylers: [{color: '#f3d19c'}]
  },
  {
    featureType: 'transit',
    elementType: 'geometry',
    stylers: [{color: '#2f3948'}]
  },
  {
    featureType: 'transit.station',
    elementType: 'labels.text.fill',
    stylers: [{color: '#d59563'}]
  },
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [{color: '#17263c'}]
  },
  {
    featureType: 'water',
    elementType: 'labels.text.fill',
    stylers: [{color: '#515c6d'}]
  },
  {
    featureType: 'water',
    elementType: 'labels.text.stroke',
    stylers: [{color: '#17263c'}]
  }
],

retro: [
  {elementType: 'geometry', stylers: [{color: '#ebe3cd'}]},
  {elementType: 'labels.text.fill', stylers: [{color: '#523735'}]},
  {elementType: 'labels.text.stroke', stylers: [{color: '#f5f1e6'}]},
  {
    featureType: 'administrative',
    elementType: 'geometry.stroke',
    stylers: [{color: '#c9b2a6'}]
  },
  {
    featureType: 'administrative.land_parcel',
    elementType: 'geometry.stroke',
    stylers: [{color: '#dcd2be'}]
  },
  {
    featureType: 'administrative.land_parcel',
    elementType: 'labels.text.fill',
    stylers: [{color: '#ae9e90'}]
  },
  {
    featureType: 'landscape.natural',
    elementType: 'geometry',
    stylers: [{color: '#dfd2ae'}]
  },
  {
    featureType: 'poi',
    elementType: 'geometry',
    stylers: [{color: '#dfd2ae'}]
  },
  {
    featureType: 'poi',
    elementType: 'labels.text.fill',
    stylers: [{color: '#93817c'}]
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry.fill',
    stylers: [{color: '#a5b076'}]
  },
  {
    featureType: 'poi.park',
    elementType: 'labels.text.fill',
    stylers: [{color: '#447530'}]
  },
  {
    featureType: 'road',
    elementType: 'geometry',
    stylers: [{color: '#f5f1e6'}]
  },
  {
    featureType: 'road.arterial',
    elementType: 'geometry',
    stylers: [{color: '#fdfcf8'}]
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry',
    stylers: [{color: '#f8c967'}]
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.stroke',
    stylers: [{color: '#e9bc62'}]
  },
  {
    featureType: 'road.highway.controlled_access',
    elementType: 'geometry',
    stylers: [{color: '#e98d58'}]
  },
  {
    featureType: 'road.highway.controlled_access',
    elementType: 'geometry.stroke',
    stylers: [{color: '#db8555'}]
  },
  {
    featureType: 'road.local',
    elementType: 'labels.text.fill',
    stylers: [{color: '#806b63'}]
  },
  {
    featureType: 'transit.line',
    elementType: 'geometry',
    stylers: [{color: '#dfd2ae'}]
  },
  {
    featureType: 'transit.line',
    elementType: 'labels.text.fill',
    stylers: [{color: '#8f7d77'}]
  },
  {
    featureType: 'transit.line',
    elementType: 'labels.text.stroke',
    stylers: [{color: '#ebe3cd'}]
  },
  {
    featureType: 'transit.station',
    elementType: 'geometry',
    stylers: [{color: '#dfd2ae'}]
  },
  {
    featureType: 'water',
    elementType: 'geometry.fill',
    stylers: [{color: '#b9d3c2'}]
  },
  {
    featureType: 'water',
    elementType: 'labels.text.fill',
    stylers: [{color: '#92998d'}]
  }
],

hiding: [
  {
    featureType: 'poi.business',
    stylers: [{visibility: 'off'}]
  },
  {
    featureType: 'transit',
    elementType: 'labels.icon',
    stylers: [{visibility: 'off'}]
  }
]
};

function buildMapLocalization(xposition, yposition) {
	  zoom=15;
	  var myposition = new google.maps.LatLng(xposition, yposition );
	  var mapOptions = {
	    zoom: zoom,
	    center: myposition,
	    mapTypeId: google.maps.MapTypeId.ROADMAP,
	    scrollwheel: false,
	    zoomControl: false,
	    streetViewControl: false,
	    rotateControl: false,
	    fullscreenControl: false,
	    gestureHandling: 'greedy'
	  };
	  map =  new google.maps.Map(document.getElementById("iframe_map"), mapOptions);
      //map.setOptions({styles: styles['silver']});

	  
	  var location=new google.maps.LatLng(xposition,yposition);
	  var marker = new google.maps.Marker({
	    position: location,
	    map: map
	  });
	  marker.setMap(map);
}



//Shows any overlays currently in the array
function showOverlays() {
   $.each( markersArray, function( k,m){
  	  m.setMap(map);
   }); 
}

//Deletes all markers in the array by removing references to them
function deleteOverlays() {
	 $.each( markersArray, function( k,m){
		  m.setMap(null);
	 });  
}


function closeInfoWindow(){
	$.each(infoArray, function( index, value ) {
		value.close();
	});
}


function buildMap(zoom,ico) {
	  var location = new google.maps.LatLng(xposition, yposition );
	  var mapOptions = {
	    zoom: zoom,
	    center: location,
	    mapTypeId: google.maps.MapTypeId.ROADMAP,
	    scrollwheel: true,
	    streetViewControl: false,
	    rotateControl: false,
	    fullscreenControl: false,
	    gestureHandling: 'greedy'
	  };

	  map =  new google.maps.Map(document.getElementById("iframe_map"), mapOptions);
	 // map.setOptions({styles: styles['silver']});
	  if (typeof ico !== 'undefined'){
		  
		  var marker = new google.maps.Marker({
			    position: location,
			    map: map
			  });  
	  }

	  
	  
}

function addMarker(coordinates1,coordinates2, contentString) {

	  var location=new google.maps.LatLng(coordinates1,coordinates2);
	  var infowindow = new google.maps.InfoWindow({
	      content: contentString
	    });

	  infoArray[coordinates1+''+coordinates2]=infowindow;

	  var marker = new google.maps.Marker({
	    position: location,
	    map: map
	  });

	    marker.addListener('click', function() {
	  
	        closeInfoWindow();
	        if (currentInfo){
	        	currentInfo.close();
	        }
	    	var yPositionClick = marker.getPosition().lng();
	    	infowindow.open(map, marker);
	        map.setZoom(12);
	      	map.setCenter(new google.maps.LatLng(marker.getPosition().lat(),yPositionClick));
	      	currentInfo=infowindow;
	      	
	    });
	  markersArray[coordinates1+''+coordinates2]=marker;
	}



$(document).scroll(function() {

	  var scrollTop = $(window).scrollTop();
	        if (scrollTop >= 1 ) {
	            $('#menu-top').removeClass("transparent");
	        }
	        else{
	        	 $('#menu-top').addClass("transparent");
	        }
	});


$(document).ready(function() {
	
	
	
	$("#contact-offer-form").validate({
		rules : {
			"localization_contact\[phone\]" : {
				required : false,
				minlength : 3,
				maxlength : 100,
			},
			"localization_contact\[email\]" : {
				required : true,
				minlength : 3,
				maxlength : 100,
			}
		},
		messages : {
			"localization_contact\[phone\]" : {
				minlength : "Min. 3 znaki",
				maxlength : "Max 100 znaków",
			},
			
			"localization_contact\[name\]" : {
				required : "Pole wymagane",
			},
			"localization_contact\[subject\]" : {
				required : "Pole wymagane",
			},
			"localization_contact\[message\]" : {
				required : "Pole wymagane",
			},
			"localization_contact\[rulesAccepted\]" : {
				required : "Pole wymagane",
			},
			
			
			"localization_contact\[email\]" : {
				minlength : "Min. 3 znaki",
				maxlength : "Max 100 znaków",
				email : "Błędny adres email",
				required : "W celu kontaktu należy podać adres email",
			},
		},
		submitHandler : function(form) {
			$.ajax({
				url : $(form).attr('action'),
				global : false,
				type : "POST",
				data: $(form).serialize(),
				dataType : "json",
				async : true,
				success : function(j) {
					switch (j.success) {
					case true:
					    document.getElementById("contact-offer-form").reset();
						$('#contact-forms-ajax-status').show();
						$('#resull-email-ajax').html(j.email);
						break;
					case false:

						break;
					}
				}
			});
		}
	});
	
	
	$('#contactModal').on('hidden.bs.modal', function (e) {
		$('#contact-forms-ajax-status').css("display", "none");
		})
	
		$('#cookie-policy-accept').on('click', function(e)
			  {
			    e.preventDefault();
			    $.cookie('cookie_policy', 1, {path: '/', expires: 365});
			    $('#cookie-policy').hide('200');
			  });
	
	
	
	$('#navbarTogglerTop').on('hide.bs.collapse', function () {
		$('.content-to-slide').removeClass("content-all-slide");
	});
	
	
	
	$('#navbarTogglerTop').on('show.bs.collapse', function () {
		$('.content-to-slide').addClass("content-all-slide");
	});
	
	$('.submitForm').on('click', function(event) {
	
		var formID=$(this).data('form');
		document.getElementById(formID).submit(); 
		
	
     });
	
	  
	$("a").on('click', function(event) {
		
		var topPadding=180;
		
		if (this.hash !== "") {
			var hash = this.hash;
			var elem = $("#" + hash.replace('#', '')).get(0);
			
			

			
			if (elem  && window.location.pathname==event.currentTarget.pathname  ) {
				if ($(this).hasClass( "change-url" )){
					window.location = currentUrl+hash;
				}else{
					$('html, body').animate({
						scrollTop : (parseInt($(hash).offset().top)-parseInt(topPadding))
					}, 800, function() {
				
					});	
				}
				event.preventDefault();
				return false;
				
			}else{
		
		
		
			}
	
		}
	});
	
	
	
	$("a").each(function() {
		if (this.hash !== "" ) {
			var check=this.hash;
			if (check==$(this).attr('href')){		
			if( $(this.hash).length==0 ){
				$(this).css("display", "none");
			}
		  }
		}
	});
	
	
	var fbPluginOrgRight=$('.fbPluginCenterOuter').css('right');
	$('.fbPluginRight').find('.fbPluginForm').hover(
		function(){
			$(this).parents('.fbPluginCenterOuter').stop(true,false).animate({
				right: -3
			}, $('.fbPluginForm').width());
		},
		function(){
			$(this).parents('.fbPluginCenterOuter').stop(true,false).animate({
				right: fbPluginOrgRight
			}, $('.fbPluginForm').width());
		}
		);

	
});

var myLazyLoad = new LazyLoad({
    elements_selector: ".lazy"
});




